import {assert, generateHeapObjID} from "../../util/TraceUtil";
import React from "react";

export const renderPrimitiveObject = (obj, connectionMap) => {
  let typ = typeof obj;

  if (obj == null) {
    return (<span className="nullObj">{getRealLabel('None')}</span>);
  }
  else if (typ === "number") {
    return (<span className="numberObj">{obj}</span>);
  }
  else if (typ === "boolean") {
    if (obj) {
      return (<span className="boolObj">{getRealLabel('True')}</span>);
    }
    else {
      return (<span className="boolObj">{getRealLabel('False')}</span>);
    }
  }
  else if (typ === "string") {
    return (<span className="stringObj">"{obj}"</span>);
  }
  else if (typ === "object") {
    if (obj[0] === 'C_DATA') {
      // handle data from C/C++ backend (C_DATA)
      let typeName = obj[2];
      let isValidPtr = ((typeName === 'pointer') &&
        (obj[3] !== '<UNINITIALIZED>') &&
        (obj[3] !== '<UNALLOCATED>'));
      let addr = obj[1];
      let extraMetadata = null;
      if (obj.length >= 5) {
        extraMetadata = obj[4];
      }
      // top-level heap ID generated by generateHeapObjID
      let cdataId = generateHeapObjID('cdata_' + addr);
      let typeSuffix = '';
      if (extraMetadata && extraMetadata.target_type) {
        typeSuffix = ' to ' + extraMetadata.target_type;
      }
      const typeNameHtml = typeName + typeSuffix;


      if (isValidPtr) {
        const ptrVal = obj[3];
        let ptrValForCss = ptrVal;
        if (extraMetadata?.su_rewritten) {
          ptrValForCss = cleanupSuTypeLabelForCss(extraMetadata?.su_rewritten); // <-- use cleanupSuTypeLabelForCss to make it into a valid CSS ID
        }
        let ptrSrcId = generateHeapObjID('ptrSrc_' + addr)
        if (ptrVal === '0x0') {
          return (<>
            <div className="typeLabel" id={cdataId}>{typeNameHtml}</div>
            <div style={{width: "10px"}} id={ptrSrcId} className="cdataElt"><span
              className="cdataUninit">NULL&nbsp;(0x0)</span>
            </div>
          </>)
        }
        let ptrTargetId = generateHeapObjID('cdata_' + ptrValForCss);
        connectionMap.set(ptrSrcId, ptrTargetId)
        return (<>
          <div className="typeLabel" id={cdataId}>{typeNameHtml}</div>
          <div style={{width: "10px"}} id={ptrSrcId} className="cdataElt">&nbsp;</div>
        </>)
      } else {
        let rep = '';
        if (typeof obj[3] === 'string') {
          let literalStr = obj[3];
          if (literalStr === '<UNINITIALIZED>') {
            rep = '?'
          } else if (literalStr === '<UNALLOCATED>') {
            rep = '\uD83D\uDC80'; // skull emoji
          } else {
            // a regular string
            literalStr = literalStr.replace(newlineAllRegex, '\\n'); // replace ALL
            literalStr = literalStr.replace(tabAllRegex, '\\t'); // replace ALL
            // unprintable chars are denoted with '???', so show them as
            // a special unicode character:
            if (typeName === 'char' && literalStr === '???') {
              literalStr = '\uFFFD'; // question mark in black diamond unicode character
            }
            else if (typeName === 'char') {
              literalStr = "'" + literalStr.replace("'", "\\'") + "'";
            }
            rep = htmlspecialchars(literalStr);
          }


        }
        else {
          // is likely a number (but note above that 'long' / 'long long' ints are encoded as strings)
          rep = obj[3];
        }
        let cdataFooter = '';
        // if cppShowBinary then display hex/binary as a footer directly below 'rep'.
        // doing so allows pointers to point into the 'middle' of a multi-byte
        // piece of data. e.g., a 4-byte int could be pointed-to by a char* to any of its 4 bytes
        // if (myViz.owner.cppShowBinary && extraMetadata) {
        //   // note: createHexBinaryDisplayDiv() possibly mutates cdataIdAlreadyInserted
        //   cdataFooter = createHexBinaryDisplayDiv(extraMetadata.hex, extraMetadata.bytes, addr);
        // }
        return (
          <>
            <div className="typeLabel">{typeNameHtml}</div>
            <div id={cdataId} className="cdataElt">{ rep + cdataFooter}
            </div>
          </>
        )
      }
      return (<>TODO C_DATA</>)
    } else if (obj[0] === 'IMPORTED_FAUX_PRIMITIVE') {
      // these represent objects that you've imported from external
      // libraries/modules, which should be displayed as 'primitives'
      // so that we don't clutter up the display by dedicating heap
      // space for them or trying to recurse into viewing their insides
      return (<span className="importedObj">{obj[1]}</span>);
    } else {
      assert(obj[0] === 'SPECIAL_FLOAT' || obj[0] === 'JS_SPECIAL_VAL');
      return (<span className="numberObj">{obj[1]}</span>);
    }
  }
  else {
    assert(false);
  }
}
export const renderCStructArray = (obj, stepNum, d3DomElement) => {
  if (obj[0] == 'C_STRUCT') {
    // assert(obj.length >= 3);
    // var addr = obj[1];
    // var typename = obj[2];
    //
    // var leader = '';
    // if (myViz.params.lang === 'cpp') {
    //   // call it 'object' instead of 'struct'
    //   d3DomElement.append('<div class="typeLabel">' + leader + 'object ' + typename + '</div>');
    // } else {
    //   d3DomElement.append('<div class="typeLabel">' + leader + 'struct ' + typename + '</div>');
    // }
    //
    // if (obj.length > 3) {
    //   d3DomElement.append('<table class="instTbl"></table>');
    //
    //   var tbl = d3DomElement.children('table');
    //
    //   let structName = obj[2] ? obj[2] : DataVisualizer.UNNAMED_PREFIX;
    //   $.each(obj, function(ind, kvPair) {
    //     if (ind < 3) return; // skip header tags
    //
    //     let fieldName = kvPair[0];
    //     if (myViz.inHideFieldsSet(structName, fieldName)) {
    //       console.log('render HIDING', structName, fieldName);
    //       myViz.fieldsHidden.push(structName + ':' + fieldName);
    //       return; // get out!
    //     }
    //
    //     tbl.append('<tr class="instEntry"><td class="instKey"></td><td class="instVal"></td></tr>');
    //
    //     var newRow = tbl.find('tr:last');
    //     var keyTd = newRow.find('td:first');
    //     var valTd = newRow.find('td:last');
    //
    //     // the keys should always be strings, so render them directly (and without quotes):
    //     // (actually this isn't the case when strings are rendered on the heap)
    //     assert(typeof kvPair[0] == "string");
    //     // common case ...
    //     var attrnameStr = htmlspecialchars(kvPair[0]);
    //     keyTd.append('<span class="keyObj">' + attrnameStr + '</span>');
    //
    //     // values can be arbitrary objects, so recurse:
    //     myViz.renderNestedObject(kvPair[1], stepNum, valTd);
    //   });
    // }
  } else if (obj[0] == 'C_MULTIDIMENSIONAL_ARRAY') {
    // // since we can display only 2 dimensions sensibly, make the first
    // // dimension into rows and flatten all other dimensions together into
    // // columns. in the common case for a 2-D array, this will do the
    // // perfect thing: first dimension is rows, second dimension is columns.
    // // e.g., for a 4-D array, the first dimension is rows, and dimensions
    // // 2, 3, and 4 are flattened together into columns. we can't do
    // // any better than this since it doesn't make sense to display
    // // more than 2 dimensions at once on screen
    // assert(obj.length >= 3);
    // var addr = obj[1];
    // var dimensions = obj[2];
    // assert(dimensions.length > 1); // make sure we're really multidimensional!
    //
    // var leader = '';
    // d3DomElement.append('<div class="typeLabel">' + leader + 'array</div>');
    // d3DomElement.append('<table class="cArrayTbl"></table>');
    // var tbl = d3DomElement.children('table');
    //
    // // a list of array indices for each dimension
    // var indicesByDimension = [];
    // for (var d = 0; d < dimensions.length; d++) {
    //   indicesByDimension.push(d3.range(dimensions[d]));
    // }
    //
    // // common case is 2-D:
    // var allDimensions = multiplyLists(indicesByDimension[0], indicesByDimension[1]);
    // // for all dimensions above the second one ...
    // for (var d = 2; d < dimensions.length; d++) {
    //   allDimensions = multiplyLists(allDimensions, indicesByDimension[d]);
    // }
    // //console.log('allDimensions', JSON.stringify(allDimensions));
    //
    // // ignore dimensions[0], which is rows
    // var numColumns = 1;
    // for (var i=1; i < dimensions.length; i++) {
    //   numColumns *= dimensions[i];
    // }
    //
    // for (var row=0; row < dimensions[0]; row++) {
    //   //console.log('row', row);
    //
    //   // a pair of rows for header + content, respectively
    //   tbl.append('<tr></tr>');
    //   var headerTr = tbl.find('tr:last');
    //   tbl.append('<tr></tr>');
    //   var contentTr = tbl.find('tr:last');
    //
    //   for (var col=0; col < numColumns; col++) {
    //     var flattenedInd = (row*numColumns) + col; // the real index into the 1-D flattened array stored in obj[3:]
    //     var realInd = flattenedInd + 3; // skip 3 header fields to get to the real index in obj
    //     var val = obj[realInd];
    //
    //     var indToDisplay = allDimensions[flattenedInd].join(',');
    //     //console.log('  col', col, '| flattenedInd:', flattenedInd, indToDisplay, 'contents:', val);
    //
    //     // add a new column and then pass in that newly-added column
    //     // as d3DomElement to the recursive call to child:
    //     headerTr.append('<td class="cMultidimArrayHeader"></td>');
    //     headerTr.find('td:last').append(indToDisplay);
    //
    //     contentTr.append('<td class="cMultidimArrayElt"></td>');
    //     myViz.renderNestedObject(val, stepNum, contentTr.find('td:last'));
    //   }
    // }
  }
  else {
    assert(obj[0] === 'C_ARRAY');
    assert(obj.length >= 2);
    let leader = '';
    d3DomElement.append('<div class="typeLabel">' + leader + 'array</div>');
    d3DomElement.append('<table class="cArrayTbl"></table>');
    var tbl = d3DomElement.children('table');

    tbl.append('<tr></tr><tr></tr>');
    var headerTr = tbl.find('tr:first');
    var contentTr = tbl.find('tr:last');
    $.each(obj, function(ind, val) {
      if (ind < 2) return; // skip 'C_ARRAY' and addr

      // add a new column and then pass in that newly-added column
      // as d3DomElement to the recursive call to child:
      headerTr.append('<td class="cArrayHeader"></td>');
      headerTr.find('td:last').append(ind - 2 /* adjust */);

      contentTr.append('<td class="cArrayElt"></td>');
      myViz.renderNestedObject(val, stepNum, contentTr.find('td:last'));
    });
    return <>todo renderCArray {obj[0]}</>
  }
  return <>todo renderCStructArray {obj[0]}</>
}

export function getRealLabel(label, lang = 'python') {
  if (lang === 'js' || lang === 'ts' || lang === 'ruby') {
    if (label === 'list') {
      return 'array';
    } else if (label === 'instance') {
      return 'object';
    } else if (label === 'True') {
      return 'true';
    } else if (label === 'False') {
      return 'false';
    }
  }

  if (lang === 'js') {
    if (label === 'dict') {
      return 'Map';
    } else if (label === 'set') {
      return 'Set';
    }
  } else if (lang === 'ruby') {
    if (label === 'dict') {
      return 'hash';
    } else if (label === 'set') {
      return 'Set'; // the Ruby Set class is capitalized
    } else if (label === 'function') {
      return 'method';
    } else if (label === 'None') {
      return 'nil';
    } else if (label === 'Global frame') {
      return 'Global Object';
    }
  } else if (lang === 'java') {
    if (label === 'None') {
      return 'null';
    } else if (label === 'True') {
      return 'true';
    } else if (label === 'False') {
      return 'false';
    }
  } else if (lang === 'c' || lang === 'cpp') {
    if (label === 'Global frame') {
      return 'Global variables';
    } else if (label === 'Frames') {
      return 'Stack';
    } else if (label === 'Objects') {
      return 'Heap';
    }
  }

  // default fallthrough case if no matches above
  return label;
}

const newlineAllRegex = new RegExp('\n', 'g');
const tabAllRegex = new RegExp("\t", 'g');
export function htmlspecialchars(str) {
  if (typeof(str) == "string") {
    str = str.replace(/&/g, "&amp;"); /* must do &amp; first */

    // ignore these for now ...
    //str = str.replace(/"/g, "&quot;");
    //str = str.replace(/'/g, "&#039;");

    str = str.replace(/</g, "&lt;");
    str = str.replace(/>/g, "&gt;");

    // replace spaces:
    //str = str.replace(/ /g, "&nbsp;");

    // replace tab as four spaces:
    str = str.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");

    // replace newline as <br/>
    str = str.replace(newlineAllRegex, '<br/>');
  }
  return str;
}

export function getRefID(obj) {
  if (obj[0] === 'REF') {
    return obj[1];
  } else {
    assert (obj[0] === 'C_DATA' && obj[2] === 'pointer');
    assert (obj[3] !== '<UNINITIALIZED>' && obj[3] !== '<UNALLOCATED>');
    return obj[3]; // pointed-to address
  }
}
export function cleanupSuTypeLabelForCss(s) {
  return s.replace(/\W/g, '_'); // \W should be anything that's not a letter, digit, or underscore
}